import React, {Component} from 'react';
import PropTypes from 'prop-types';
import WithCurrencyConfig from "@checkout-c/WithCurrencyConfig";
import {getJSFormattedCurrency, toDecimals} from "@checkout-h/currency";
import Translation from "@showclix-shared/CheckoutProcess/components/Translation";
import Button from "@checkout-s/Button";
import {withTranslation} from '@checkout-c/Translations';

class DummyLoyaltyComponent extends Component {
  getFormattedCurrency = amount => {
    return this.props.currencyConfig ? getJSFormattedCurrency(amount, this.props.currencyConfig) : '';
  }

  constructor(props) {
    super(props);
    this.state = {
      amount: 0.00,
    };
  }

  componentDidMount() {
    if (this.props.amountSet) {
      this.setState({ amount: this.props.amountSet / 100 });
    }
  }

  toFixed(num) {
    return num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
  }

  handleAmountChange = (event) => {
    if (isNaN(event.target.value)) {
      this.props.setLoyaltyError('checkout__loyalty_invalid_amount');
      event.target.value = '';
    } else if (event.target.value == '') {
      event.target.value = '';
    } else {
      if (event.target.value < 0) {
        this.props.setLoyaltyError('checkout__loyalty_invalid_amount');
      }
      event.target.value = this.toFixed(event.target.value, 2)
    }
    this.setState({amount: event.target.value});
  }

  hasChanges = () => {
    if (!this.props.amountSet) {
      return false;
    }

    return (this.props.amountSet / 100) !== Number(this.state.amount);
  }

  render() {
    return (
      <div className="loyalty-program">
        <div className="form-card__header" {...this.props.amountAvailable.amount == 0 ? {style: {borderBottom: 0}} : {}}>
          <h3 className="form-card__heading">Dummy</h3>
          <span style={{paddingLeft:"16px"}}>{this.getFormattedCurrency(this.props.amountAvailable.amount)} <Translation>{'checkout__available'}</Translation></span>
        </div>
        {this.props.amountAvailable.amount > 0 && <div className="form-card__content">
          {!!this.props.loyaltyErrorMessage && (
            <div id="loyalty-error" className="loyalty-error" aria-live="assertive" aria-atomic="true" role="alert">
              <i className="icon-report" />
              {this.props.loyaltyErrorMessage}
            </div>
          )}
          <div className="input">
            <div className="checkout-form__dummy">
              <div className="input__horizontal">
                <div className="input__wrapper">
                  <p className="currency-symbol">$</p>
                  <input
                    id="dummy-loyalty-amount"
                    type="number"
                    step="0.01"
                    min="0"
                    max={toDecimals(this.props.amountAvailable)}
                    value={this.state.amount}
                    onChange={this.handleAmountChange}
                    className="input__control"
                    placeholder="0.00"
                    aria-label={this.props.t('checkout__loyalty_program_amount')}
                    aria-describedby="loyalty-error"
                  />
                </div>
                {(!this.props.amountSet || this.hasChanges()) && (
                  <Button
                    onClick={e => {this.props.updateLoyaltyAmount(this.state.amount)}}
                    className="button--primary button--medium"
                    loading={this.props.loyaltyUpdateLoading}
                  >
                    <Translation>{this.props.loyaltyApplied ? 'checkout__update' : 'checkout__apply'}</Translation>
                  </Button>
                )}
                {(this.props.amountSet > 0 && !this.hasChanges()) && (
                  <p className="applied-amount">
                    <i className="icon-check" />
                    <Translation interpolation={{ provider: 'DummyLoyalty' }}>
                      {'checkout__loyalty_applied'}
                    </Translation>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>}
      </div>
    );
  }
}

DummyLoyaltyComponent.propTypes = {
  id: PropTypes.string,
  type: PropTypes.number,
  amountAvailable: PropTypes.object,
};

export default withTranslation(WithCurrencyConfig(DummyLoyaltyComponent));
